import { render, staticRenderFns } from "./AdminsPage.vue?vue&type=template&id=81df2332&scoped=true&"
import script from "./AdminsPage.vue?vue&type=script&lang=js&"
export * from "./AdminsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81df2332",
  null
  
)

export default component.exports